import './package-configurations';
import './polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import BrowserApp from './BrowserApp';

ReactDOM.hydrate(<BrowserApp />, document.getElementById('root'));
